import {VideoPubEvent} from "../../../constants/Janus/VideoRoom/Publisher";

export const attachVRoomPub = (Janus: any, janus: any, opaqueId: string, secret: string | undefined, pin: string | undefined, username: string, isPublisher: boolean, callback: any) => {
    let pubPlugin: any = null;
    let myStream: any = null;

    if (!janus) {
        return;
    }

    janus.attach(
        {
            plugin: "janus.plugin.videoroom",
            opaqueId: opaqueId,
            success: function(pluginHandle: any) {
                // $('#details').remove();
                pubPlugin = pluginHandle;
                Janus.log("Plugin attached! (" + pubPlugin.getPlugin() + ", id=" + pubPlugin.getId() + ")");
                Janus.log("  -- This is a publisher/manager");
                // Prepare the username registration
                // $('#videojoin').removeClass('hide').show();
                // $('#registernow').removeClass('hide').show();
                // $('#register').click(registerUsername);
                // $('#username').focus();
                // $('#start').removeAttr('disabled').html("Stop")
                //     .click(function() {
                //         $(this).attr('disabled', true);
                //         janus.destroy();
                //     });
                callback(pubPlugin, VideoPubEvent.SUCCESS);
            },
            error: function(error: any) {
                Janus.error("  -- Error attaching plugin...", error);
                // bootbox.alert("Error attaching plugin... " + error);
                callback(pubPlugin, VideoPubEvent.ERROR);
            },
            consentDialog: function(on: boolean) {
                Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
                // if(on) {
                //     // Darken screen and show hint
                //     $.blockUI({
                //         message: '<div><img src="up_arrow.png"/></div>',
                //         css: {
                //             border: 'none',
                //             padding: '15px',
                //             backgroundColor: 'transparent',
                //             color: '#aaa',
                //             top: '10px',
                //             left: (navigator.mozGetUserMedia ? '-100px' : '300px')
                //         } });
                // } else {
                //     // Restore screen
                //     $.unblockUI();
                // }
                callback(pubPlugin, VideoPubEvent.CONSENT_DIALOG, on);
            },
            iceState: function(state: any) {
                Janus.log("ICE state changed to " + state);
                callback(pubPlugin, VideoPubEvent.ICE_STATE, state);
            },
            mediaState: function(medium: any, on: boolean) {
                Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium);
                callback(pubPlugin, VideoPubEvent.MEDIA_STATE, {medium, on});
            },
            webrtcState: function(on: boolean) {
                Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
                // $("#videolocal").parent().parent().unblock();
                // if(!on)
                //     return;
                // $('#publish').remove();
                // // This controls allows us to override the global room bitrate cap
                // $('#bitrate').parent().parent().removeClass('hide').show();
                // $('#bitrate a').click(function() {
                //     var id = $(this).attr("id");
                //     var bitrate = parseInt(id)*1000;
                //     if(bitrate === 0) {
                //         Janus.log("Not limiting bandwidth via REMB");
                //     } else {
                //         Janus.log("Capping bandwidth to " + bitrate + " via REMB");
                //     }
                //     $('#bitrateset').html($(this).html() + '<span class="caret"></span>').parent().removeClass('open');
                //     sfutest.send({ message: { request: "configure", bitrate: bitrate }});
                //     return false;
                // });
                callback(pubPlugin, VideoPubEvent.WEBRTC_STATE, on);
            },
            onmessage: function(msg: any, jsep: any) {
                Janus.debug(" ::: Got a message (publisher) :::", msg);
                let event = msg["videoroom"];
                Janus.debug("Event: " + event);
                if(event) {
                    if(event === "joined") {
                        // Publisher/manager created, negotiate WebRTC and attach to existing feeds, if any
                        // myid = msg["id"];
                        // mypvtid = msg["private_id"];
                        Janus.log("Successfully joined room " + msg["room"] + " with ID " + msg["id"]);
                        // if(subscriber_mode) {
                        //     $('#videojoin').hide();
                        //     $('#videos').removeClass('hide').show();
                        // } else {
                        //     publishOwnFeed(true);
                        // }
                        // // Any new feed to attach to?
                        // if(msg["publishers"]) {
                        //     var list = msg["publishers"];
                        //     Janus.debug("Got a list of available publishers/feeds:", list);
                        //     for(var f in list) {
                        //         var id = list[f]["id"];
                        //         var display = list[f]["display"];
                        //         var audio = list[f]["audio_codec"];
                        //         var video = list[f]["video_codec"];
                        //         Janus.debug("  >> [" + id + "] " + display + " (audio: " + audio + ", video: " + video + ")");
                        //         newRemoteFeed(id, display, audio, video);
                        //     }
                        // }
                        callback(pubPlugin, VideoPubEvent.JOINED, msg);
                    } else if(event === "destroyed") {
                        // The room has been destroyed
                        Janus.warn("The room has been destroyed!");
                        // bootbox.alert("The room has been destroyed", function() {
                        //     window.location.reload();
                        // });
                        callback(pubPlugin, VideoPubEvent.DESTROYED)
                    } else if(event === "event") {
                        // Any new feed to attach to?
                        if(msg["publishers"]) {
                            let list = msg["publishers"];
                            Janus.debug("Got a list of available publishers/feeds:", list);
                            // for(var f in list) {
                            //     var id = list[f]["id"];
                            //     var display = list[f]["display"];
                            //     var audio = list[f]["audio_codec"];
                            //     var video = list[f]["video_codec"];
                            //     Janus.debug("  >> [" + id + "] " + display + " (audio: " + audio + ", video: " + video + ")");
                            //     newRemoteFeed(id, display, audio, video);
                            // }
                            callback(pubPlugin, VideoPubEvent.PUBLISHERS, msg["publishers"]);
                        } else if(msg["leaving"]) {
                            // One of the publishers has gone away?
                            let leaving = msg["leaving"];
                            Janus.log("Publisher left: " + leaving);
                            // var remoteFeed = null;
                            // for(var i=1; i<6; i++) {
                            //     if(feeds[i] && feeds[i].rfid == leaving) {
                            //         remoteFeed = feeds[i];
                            //         break;
                            //     }
                            // }
                            // if(remoteFeed != null) {
                            //     Janus.debug("Feed " + remoteFeed.rfid + " (" + remoteFeed.rfdisplay + ") has left the room, detaching");
                            //     $('#remote'+remoteFeed.rfindex).empty().hide();
                            //     $('#videoremote'+remoteFeed.rfindex).empty();
                            //     feeds[remoteFeed.rfindex] = null;
                            //     remoteFeed.detach();
                            // }
                            callback(pubPlugin, VideoPubEvent.LEAVING, msg["leaving"]);
                        } else if(msg["unpublished"]) {
                            // One of the publishers has unpublished?
                            let unpublished = msg["unpublished"];
                            Janus.log("Publisher left: " + unpublished);
                            // if(unpublished === 'ok') {
                            //     // That's us
                            //     sfutest.hangup();
                            //     return;
                            // }
                            // var remoteFeed = null;
                            // for(var i=1; i<6; i++) {
                            //     if(feeds[i] && feeds[i].rfid == unpublished) {
                            //         remoteFeed = feeds[i];
                            //         break;
                            //     }
                            // }
                            // if(remoteFeed != null) {
                            //     Janus.debug("Feed " + remoteFeed.rfid + " (" + remoteFeed.rfdisplay + ") has left the room, detaching");
                            //     $('#remote'+remoteFeed.rfindex).empty().hide();
                            //     $('#videoremote'+remoteFeed.rfindex).empty();
                            //     feeds[remoteFeed.rfindex] = null;
                            //     remoteFeed.detach();
                            // }
                            callback(pubPlugin, VideoPubEvent.UNPUBLISHED, msg["unpublished"]);
                        } else if(msg["error"]) {
                            // if(msg["error_code"] === 426) {
                            //     // This is a "no such room" error: give a more meaningful description
                            //     bootbox.alert(
                            //         "<p>Apparently room <code>" + myroom + "</code> (the one this demo uses as a test room) " +
                            //         "does not exist...</p><p>Do you have an updated <code>janus.plugin.videoroom.jcfg</code> " +
                            //         "configuration file? If not, make sure you copy the details of room <code>" + myroom + "</code> " +
                            //         "from that sample in your current configuration file, then restart Janus and try again."
                            //     );
                            // } else {
                            //     bootbox.alert(msg["error"]);
                            // }
                            callback(pubPlugin, VideoPubEvent.ERROR_EVENT, msg);
                        }
                    }
                }
                if(jsep) {
                    Janus.debug("Handling SDP as well...", jsep);
                    pubPlugin.handleRemoteJsep({ jsep: jsep });
                    // Check if any of the media we wanted to publish has
                    // been rejected (e.g., wrong or unsupported codec)
                    let audio = msg["audio_codec"];
                    if(myStream && myStream.getAudioTracks() && myStream.getAudioTracks().length > 0 && !audio) {
                        // Audio has been rejected
                        // toastr.warning("Our audio stream has been rejected, viewers won't hear us");
                    }
                    let video = msg["video_codec"];
                    if(myStream && myStream.getVideoTracks() && myStream.getVideoTracks().length > 0 && !video) {
                        // Video has been rejected
                        // toastr.warning("Our video stream has been rejected, viewers won't see us");
                        // Hide the webcam video
                        // $('#myvideo').hide();
                        // $('#videolocal').append(
                        //     '<div class="no-video-container">' +
                        //     '<i class="fa fa-video-camera fa-5 no-video-icon" style="height: 100%;"></i>' +
                        //     '<span class="no-video-text" style="font-size: 16px;">Video rejected, no webcam</span>' +
                        //     '</div>');
                    }
                }
            },
            onlocalstream: function(stream: any) {
                Janus.debug(" ::: Got a local stream :::", stream);
                myStream = stream;
                // $('#videojoin').hide();
                // $('#videos').removeClass('hide').show();
                // if($('#myvideo').length === 0) {
                //     $('#videolocal').append('<video class="rounded centered" id="myvideo" width="100%" height="100%" autoplay playsinline muted="muted"/>');
                //     // Add a 'mute' button
                //     $('#videolocal').append('<button class="btn btn-warning btn-xs" id="mute" style="position: absolute; bottom: 0px; left: 0px; margin: 15px;">Mute</button>');
                //     $('#mute').click(toggleMute);
                //     // Add an 'unpublish' button
                //     $('#videolocal').append('<button class="btn btn-warning btn-xs" id="unpublish" style="position: absolute; bottom: 0px; right: 0px; margin: 15px;">Unpublish</button>');
                //     $('#unpublish').click(unpublishOwnFeed);
                // }
                // $('#publisher').removeClass('hide').html(myusername).show();
                // Janus.attachMediaStream($('#myvideo').get(0), stream);
                // $("#myvideo").get(0).muted = "muted";
                // if(sfutest.webrtcStuff.pc.iceConnectionState !== "completed" &&
                //     sfutest.webrtcStuff.pc.iceConnectionState !== "connected") {
                //     $("#videolocal").parent().parent().block({
                //         message: '<b>Publishing...</b>',
                //         css: {
                //             border: 'none',
                //             backgroundColor: 'transparent',
                //             color: 'white'
                //         }
                //     });
                // }
                // var videoTracks = stream.getVideoTracks();
                // if(!videoTracks || videoTracks.length === 0) {
                //     // No webcam
                //     $('#myvideo').hide();
                //     if($('#videolocal .no-video-container').length === 0) {
                //         $('#videolocal').append(
                //             '<div class="no-video-container">' +
                //             '<i class="fa fa-video-camera fa-5 no-video-icon"></i>' +
                //             '<span class="no-video-text">No webcam available</span>' +
                //             '</div>');
                //     }
                // } else {
                //     $('#videolocal .no-video-container').remove();
                //     $('#myvideo').removeClass('hide').show();
                // }
                callback(pubPlugin, VideoPubEvent.ON_LOCAL_STREAM, stream);
            },
            onremotestream: function(stream: any) {
                // The publisher stream is sendonly, we don't expect anything here
            },
            oncleanup: function() {
                Janus.log(" ::: Got a cleanup notification: we are unpublished now :::");
                myStream = null;
                // $('#videolocal').html('<button id="publish" class="btn btn-primary">Publish</button>');
                // $('#publish').click(function() { publishOwnFeed(true); });
                // $("#videolocal").parent().parent().unblock();
                // $('#bitrate').parent().parent().addClass('hide');
                // $('#bitrate a').unbind('click');
                callback(pubPlugin, VideoPubEvent.ON_CLEAN_UP)
            }
        });


}

export const joinVideoRoom = (pubPlugin: any, roomId: number, display: string, ptype = "publisher", pid = null) => {
    let requestJoinMsg = {
        request: "join",
        room: roomId,
        ptype: ptype,
        display: display,
    };
    // if (pid) {
    //     requestJoinMsg.feed = pid;
    // }
    pubPlugin.send({message: requestJoinMsg});
}

export const publishScreen = (Janus: any, pubPlugin: any, callback: any) => {
    pubPlugin.createOffer(
        {
            media: { video: "screen", audioSend: false, videoRecv: false},	// Screen sharing Publishers are sendonly
            success: function(jsep: any) {
                Janus.debug("Got publisher SDP!", jsep);
                let publish = { request: "configure", audio: false, video: true };
                pubPlugin.send({ message: publish, jsep: jsep });
                callback("success");
            },
            error: function(error: any) {
                Janus.error("WebRTC error:", error);
                callback("error", pubPlugin, error);
            }
        });
}

export const publishStreamFeed = (Janus: any, pubPlugin: any, stream: any, useVideo = true, useAudio = true, data = true, bitrate = 256000, simulcast = false, callback: any) => {
    pubPlugin.createOffer(
        {
            // video: "lowres",
            // iceRestart: true,
            stream: stream,
            media: {audioRecv: false, videoRecv: false},	// Publishers are sendonly
            simulcast: simulcast,

            success: function (jsep: any) {
                Janus.debug("Got publisher SDP!");
                console.log("Publish own feed success");
                Janus.debug(jsep);
                let publish = {request: "configure", audio: useAudio, video: true, bitrate: bitrate};

                pubPlugin.send({message: publish, jsep: jsep});
                callback("success", jsep);
            },
            error: function (error: any) {
                Janus.debug("Publisher Error!", error);
                callback("error", error);
                // setTimeout(() => {
                //     publishOwnFeed(pubPlugin, true, false, data, bitrate, simulcast);
                // }, [2000])
            }
        }
    );
};

export function publishOwnFeed(pubPlugin: any, useAudio: boolean,  doSimulcast = false, callback: any) {
    pubPlugin.createOffer(
        {
            // Add data:true here if you want to publish datachannels as well
            media: { audioRecv: false, videoRecv: false, audioSend: useAudio, videoSend: true },	// Publishers are sendonly
            // If you want to test simulcasting (Chrome and Firefox only), then
            // pass a ?simulcast=true when opening this demo page: it will turn
            // the following 'simulcast' property to pass to janus.js to true
            simulcast: doSimulcast,
            customizeSdp: function(jsep: any) {
                // If DTX is enabled, munge the SDP
                // if(doDtx) {
                //     jsep.sdp = jsep.sdp
                //         .replace("useinbandfec=1", "useinbandfec=1;usedtx=1")
                // }
            },
            success: function(jsep: any) {
                // Janus.debug("Got publisher SDP!", jsep);
                let publish = { request: "configure", audio: useAudio, video: true };
                // You can force a specific codec to use when publishing by using the
                // audiocodec and videocodec properties, for instance:
                // 		publish["audiocodec"] = "opus"
                // to force Opus as the audio codec to use, or:
                // 		publish["videocodec"] = "vp9"
                // to force VP9 as the videocodec to use. In both case, though, forcing
                // a codec will only work if: (1) the codec is actually in the SDP (and
                // so the browser supports it), and (2) the codec is in the list of
                // allowed codecs in a room. With respect to the point (2) above,
                // refer to the text in janus.plugin.videoroom.jcfg for more details.
                // We allow people to specify a codec via query string, for demo purposes
                // if(acodec)
                //     publish["audiocodec"] = acodec;
                // if(vcodec)
                //     publish["videocodec"] = vcodec;
                pubPlugin.send({ message: publish, jsep: jsep });
                callback("success", jsep);
            },
            error: function(error: any) {
                // Janus.error("WebRTC error:", error);
                // if(useAudio) {
                //     publishOwnFeed(false);
                // } else {
                //     bootbox.alert("WebRTC error... " + error.message);
                //     $('#publish').removeAttr('disabled').click(function() { publishOwnFeed(true); });
                // }
                callback("error", error);
            }
        });
}

export function unpublishOwnFeed(pubPlugin: any) {
    // Unpublish our stream
    // $('#unpublish').attr('disabled', true).unbind('click');
    let unpublish = { request: "unpublish" };
    pubPlugin.send({ message: unpublish });
}